import {
  commonUtils,
  MainNavTab,
  TabMainNavProps,
  textUtils,
} from '@sato/components';

import {
  ConditionDependencies,
  filterConditionalEntries,
} from '@/contentful/components';
import {
  IListedLink,
  IMainNav,
  isContentType,
  ParsedEntry,
} from '@/contentful/types';

import { Link } from '@components/common/Link';
import { LANGUAGES } from '@models/Language';

export const parseMainNavTabs = (
  data: ParsedEntry<IMainNav>,
  conditionDeps: ConditionDependencies
): TabMainNavProps<typeof Link>['tabs'] => {
  const formatLink = ({ id, url, title, icon }: ParsedEntry<IListedLink>) => ({
    id,
    to: url,
    children: title,
    icon: icon?.icon,
  });

  return filterConditionalEntries(data.links, { deps: conditionDeps })
    .map((linkGroup) => {
      if (isContentType(linkGroup, 'listedLinkList')) {
        return {
          id: linkGroup.id,
          title: linkGroup.title,
          links: filterConditionalEntries(linkGroup.links, {
            deps: conditionDeps,
          }).map(formatLink),
        } satisfies MainNavTab<typeof Link>;
      } else if (isContentType(linkGroup, 'listedLink')) {
        return formatLink(linkGroup);
      }

      return null;
    })
    .filter(commonUtils.nonNullable);
};

export const LANGUAGE_SELECTIONS = LANGUAGES.map(
  (language) =>
    ({
      label: textUtils.toUpperCase(language),
      value: language,
    }) as const
);
